import React from "react";

const SearchIcon = ({fill}: {fill?: string}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6938 17.8188H18.7063L18.3563 17.4813C19.5813 16.0563 20.3188 14.2063 20.3188 12.1938C20.3188 7.70635 16.6813 4.06885 12.1938 4.06885C7.70626 4.06885 4.06876 7.70635 4.06876 12.1938C4.06876 16.6813 7.70626 20.3188 12.1938 20.3188C14.2063 20.3188 16.0563 19.5813 17.4813 18.3563L17.8188 18.7063V19.6938L24.0688 25.9313L25.9313 24.0688L19.6938 17.8188ZM12.1938 17.8188C9.08126 17.8188 6.56876 15.3063 6.56876 12.1938C6.56876 9.08135 9.08126 6.56885 12.1938 6.56885C15.3063 6.56885 17.8188 9.08135 17.8188 12.1938C17.8188 15.3063 15.3063 17.8188 12.1938 17.8188Z"
        fill={fill || "black"}
      />
    </svg>
  );
};

export default SearchIcon